import { apiClient } from 'lib/api-client';
import { isDemoMode } from 'config/demo-mode';
import { getDemoSession, loginDemo, logoutDemo } from 'demo/auth-service';

import type { LoginRequest, LoginResponse, LogoutResponse, MeResponse } from '../types/auth';

export async function login(request: LoginRequest) {
  if (isDemoMode) return loginDemo(request);

  const response = await apiClient.post<LoginResponse>('/api/v1/auth/login', request);

  return response.data.data.user;
}

export async function getCurrentUser() {
  if (isDemoMode) return getDemoSession();

  const response = await apiClient.get<MeResponse>('/api/v1/auth/me');

  return response.data.data.user;
}

export async function logout() {
  if (isDemoMode) {
    await logoutDemo();
    return { message: 'Logged out successfully' };
  }

  const response = await apiClient.post<LogoutResponse>('/api/v1/auth/logout');

  return response.data.data;
}
